module.exports = __webpack_public_path__ + "static/img/tow.50e37ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pinDupLeImg/tow.png
// module id = 4lDO
// module chunks = 1